<template>
  <div class="m-content" >
  	<HeaderBox/>
    <div class="report-content">
      <div class="report-type">
        <p class="report-title">你的决策风格类型为</p>
        <h3 class="type-title">{{cosDecision}}</h3>
        <p v-html="reportText[cosDecision][0]"></p>
      </div>
      <template v-if="reportText[cosDecision]">
        <div class="report-area">
          <p class="report-title">行为表现</p>
          <p v-html="reportText[cosDecision][1]"></p>
        </div>
        <div class="report-area">
          <p class="report-title">优势</p>
          <p v-html="reportText[cosDecision][2]"></p>
        </div>
        <div class="report-area">
          <p class="report-title">劣势</p>
          <p v-html="reportText[cosDecision][3]"></p>
        </div>
        <div class="report-area">
          <p class="report-title">建议</p>
          <p v-html="reportText[cosDecision][4]"></p>
        </div>
      </template>
    </div>
  	<FootBox :id="id"/>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
import HeaderBox from '@/components/mission/headerBox.vue'
import FootBox from '@/components/mission/footBox.vue'
import setWechatTitle from '@/utils/setWechatTitle.js'

export default {
  props: {
    id: Number
  },
  name: 'DecisionReport',
  components: {
    HeaderBox,
    FootBox
  },
  data() {
    return {
      cosDecision:'',
      reportText:{
        '理智型':
        ['理智型决策风格的人在做决策时会探索大量丰富有用的信息，并且利用自己缜密的逻辑性对信息加以利用，给人一种“网罗天下信息为我所用”的感觉。',
        '理智型的人在面对毕业去向和职业生涯发展时，有如下表现：</br><b>系统搜集信息：</b>会系统的搜集各方面的信息，尤其是自我探索和外部探索两方面的信息。包括对自己的兴趣、价值观、能力以及对职业环境、行业和职业等多种维度进行充分的探索。</br><b>拓展决策选项：</b>在掌握大量信息的基础上，拓展出多种不同的决策选项，如读研、国企、私企、公务员等。</br><b>进行决策评估：</b>会详细的分析每一个选项对你的利弊得失，以确保自己能够做出适当且明智的选择。</br>',
        '<b>判断标准明确：</b>你知道什么样的决策对你而言是好的决策，所以在决定自己的毕业去向或职业生涯这个问题上你都有自己的判断标准，知道自己看重的是哪些因素，哪些选择符合这些因素，不断地对每种选项进行比较。</br><b>决策风险小：</b>在拓展决策选项的过程中你会搜集很多很多的信息，这样容易给自己带来安全感，避免一些因决策失误而带来的风险，</br><b>容易执行：</b>当下做出的决策于你来说是比较合适的、正确的决策，所以在实施的过程中若是遇到问题，你也会主动积极的去面对，并加以解决。</br>',
        '<b>耗时较长：</b>理智型的你会在掌握大量信息的前提下做出自己认为“好”的决策，所以花费的时间会很长。</br><b>容易错失良机：</b>这样过于理想的你往往会因为做出一个好的决策结果会丧失很多绝佳的时机，比如面临毕业去向抉择时，去哪读研？选择哪个offer等等，你都要权衡许久才能做出最后的决定。</br><b>容易忽略自己的情感倾向：</b>过于理智的你可能会缺乏一些人情味和激情，因为你是依据大量的信息做出的决策，容易忽略自己内心的想法和直觉。',
        '<b>好的决策风格是理智加上相信自己的直觉，</b>以毕业去向的抉择为例，理智型的你要想做出一个好的决策，你已经达到了一半的要求，剩下的一半就是需要<b>相信自己的直觉，</b>倾听自己内心的声音，依靠自己的直觉做出判断，避免陷入追求过度的理智而陷入焦虑。'
        ],
        '直觉型':[
          '直觉型决策风格的人在做出决策时会依赖自己的直觉，也就是根据感觉而非思考来做决定，凡事跟着感觉走， “感觉这个还不错，就这个了”。',
          '<b>以自我判断为导向：</b>直觉型的你以自我判断为导向，只考虑自己想要的，跟着自己的感觉走，不在乎外在的因素。例如在决定自己的毕业去向时，你会根据自己对所有可能去向的感觉，感觉哪个选项适合自己就选哪个。</br><b>重视自己的主观经验：</b>你在决策过程中不会过度依赖系统性和详尽的问题分析和评估方法，而是结合自己的经验来进行选择和判断。</br><b>满意度优先：</b>因为你是借助自己的经验和感觉做出的决策，所以可能对你而言选择的是让自己满意的方案而不是最优的方案。',
          '<b>激发创新思维：</b>直觉型的你可以免受理性决策思路带来的束缚而发掘出更有创新的想法，容易产生激情、创意，思维也比较自由。</br><b>减少决策过程中的焦虑：</b>决策的产生主要是依赖自己的直觉和感觉，速度会很快，马上就能够做出一个决定，简单省事，能够避免决策过程中的焦虑。例如在面对毕业后求职这个问题时，从事哪种职业呢？你的大脑中已经生成了一个相对明确的答案，所以你就不必要对每一个摆在面前的选择进行分析和权衡',
          '<b>决策依据过于主观，容易决策失误：</b>你主要是依据自己的主观经验和直觉来做出决策，如果你经验积累得不够，过于相信自己的直觉，则会造成信息不全的情况。尤其是面对毕业去向或职业生涯发展这种对自己个人生涯非常关键的重大决策时，如果缺乏信息基础，过度依靠自己的直觉，有可能做出一个错误或者不适合你的决策，容易后悔',
          '<b>好的决策风格是理智加上相信自己的直觉，而理智的决策是以充分的信息为基础。</b>以毕业去向的抉择为例，直觉型的你要想做出一个好的决策，你需要：</br><b>1.	了解“自我”的信息：</b>包括自己的职业兴趣、职业价值观、性格特征是什么，能力如何，是否具备了清晰的目标等等。</br><b>2.	了解外部信息：</b>如果你是找工作，你需要了解关于“职业”的信息，包括当下的职业大环境如何、自己意向的行业和职业相关的信息、对于大学生就业的相关扶持政策等等。如果你是考研，那么你就需要对自己意向的学校、招生信息、培养目标、奖助政策等进行了解。</br><b>3.	信息与直觉相结合：</b>好的决策需要以大量信息为基础，再加上自己的直觉，所以不能过于依赖直觉而忽视了信息的基础作用，而是将两者相结合，助力最佳决策的产生。'
          ],
        '依赖型':[
          '依赖型决策风格的人最大的特征就是在做决策时会寻求他人的指导和建议，“你说选择什么我就选择什么”、“你说OK我就OK”，比较被动和顺从。',
          '<b>依赖他人：</b>在面临毕业去向或职业生涯发展这个问题上，你希望有个人能够给你提供建议，告诉你应该如何做出决策，甚至是希望有人能够直接替你做出选择。而身边的重要朋友、家人和老师是你经常依赖的对象，只要遇到重大的决策问题时，你都会寻求他们的意见。</br><b>忽视自我意见：</b>你的决策都是在他人协助下产生的，所以会忽视自己的想法，不能按照自己的想法做决定。</br><b>转移决策责任：</b>因为你不能够承担自己做决策的责任。所以你会将决策的责任部分转移到他人身上，允许他人参与到自己的决策当中来。',
          '<b>缓解决策压力：</b>毕业去向和职业生涯发展问题本身就是人生中的关键问题，所以你希望得到别人的帮助和对决策的认可，允许别人参与到自己的决策当中，这样就能够将一部分决策的责任转移到他人身上，从而减轻自己的压力。</br><b>容易产生决策成果：</b>如果遇到“靠谱”的人，那么你很快会做出“靠谱”的决策。',
          '<b>忽略自己的想法：</b>依赖型的你会事事寻求他人指导和建议，没有自己的想法，容易缺乏主见，可能最后的决策并不是你想要的，但是你也会接受。</br><b>容易滋生惰性的习惯：</b>过度依赖他人，不利于激发自己的主动性，惰性很强。</br><b>容易丧失自我控制感：</b>寻求他人指导，甚至替自己决策，将决策的责任部分转移到他人身上，容易丧失自己对决策的控制感，使自己成为别人意见的执行者。</br><b>结果不可控：</b>他人只是帮助你做出决策但是不会帮你承担决策带来的后果，需要自己去买单决策带来的后果，如果遇到“不靠谱”的人，代价会很大。',
          '<b>好的决策风格是理智加上相信自己的直觉，而理智的决策是以充分的信息为基础。</b>以毕业去向的抉择为例，依赖型的你要想做出一个好的决策，你需要：</br><b>1.	了解关于“自我”的信息：</b>包括自己的职业兴趣、职业价值观、性格特征是什么，能力如何，是否具备了清晰的目标等等。</br><b>2.	了解外部环境的信息：</b>如果你是求职，你需要了解与职业有关的信息，包括当下的职业大环境如何、自己意向的行业和职业相关的信息、对于大学生就业的相关扶持政策等等。如果你是考研，你需要对自己意向的学校、招生信息、培养目标、奖助政策等进行了解。</br><b>3.	培养独立决策的能力：</b>独立性是大学生必备的素质之一，从小的决策做起，逐渐培养自己独立决策的能力，形成自己的主见，相信自己的直觉。在决策困难很大的情况再去寻求他人支持。'
        ],
        '回避型':[
          '回避型决策风格的人往往以试图回避做出决策为特征，什么事情都是以后再说，以后再考虑，其实这是一种拖延、不果断的方式。',
          '<b>回避/逃避/拖延决策：</b>回避型的你面对决策时会产生焦虑，尤其是面对毕业去向或职业生涯发展这样对个人发展有重要意义的决策时，往往因为害怕做出错误的决策而无法承担后果时，采取回避的行为。</br><b>缺乏准备性：</b>倾向于不考虑未来的发展方向，不去做准备，不知道自己毕业后的目标是什么，也不去思考，更不会寻求帮助。',
          '<b>减轻决策的痛苦，缓解焦虑：</b> “回避问题”可以作为“缓兵之计”，暂时避免做出决策，这样一来就不用面对决策过程中出现的各种问题，也不用承担决策带来的后果。因为有关毕业去向或职业生涯发展的问题，本身就是一个不断澄清自己价值观做出选择的复杂过程，而暂时回避这个问题，可以减轻痛苦，避免焦虑，并且还会找各种理由进行自我安慰。',
          '<b>错失机会：</b>回避问题只是暂时不用去思考这些问题但是无法起到解决问题的作用，比如在面临毕业后何去何从这个问题，如果一直回避不做出决策，会错失很多的机会。</br><b>积压消极情绪：</b>如果一直回避做出决策，那么这个问题就会一直存在，尤其是当看到别人在为自己的目标努力时，自己还没有想法，这样就容易积累消极的情绪，积累压力。',
          '<b>好的决策风格是理智加上相信自己的直觉，而理智的决策是以充分的信息为基础，而回避无法从根本上解决问题。</b>以毕业去向的抉择为例，回避型的你要想做出一个好的决策，你需要： </br><b>1.	了解关于“自我”的信息：</b>包括自己的职业兴趣、职业价值观、性格特征是什么，能力如何等。</br><b>2.	了解外部信息：</b>如果你是找工作，你就需要了解关于“职业”的信息，包括当下的职业大环境如何、自己意向的行业和职业相关的信息、对于大学生就业的相关扶持政策等等。如果你是打算考研，那么你就不能临近报名才去考虑专业和学校选择的问题，需要对自己意向的学校、招生信息、培养目标、奖助政策等进行了解。</br><b>3.	明确目标，提前准备：</b>不管是工作还是读研，都要明确自己的目标，做好各方面的准备，积极主动的去面对，在了解充分的信息基础上相信自己的直觉。'
        ],
        '自发型':[
          '自发型决策风格的人渴望即刻、尽快完成决策为特征，是一种具有强烈即时性，并对快速做决策的过程有兴趣， “先这样再说，以后再想后果”，可以用长痛不如短痛、快刀斩乱麻来形容。',
          '<b>注重决策的及时性：</b>该种决策风格的你往往不能够容忍决策的不确定性以及由此带来的焦虑情绪，具有强烈的即时性，快速做出决策。</br><b>决策较为冲动：</b>经常会基于一时的冲动，在缺乏深思熟虑的情况下就做出了决策。所以，在面临毕业后何去何从或职业生涯发展这个问题上，你可能会在一时的冲动下就做出了选择，也正是如此，会给人一种果断或过于冲动的感觉。',
          '<b>决策速度快：</b>自发型的决策风格有理智和直觉的成分，但不是理智和直觉的结合，在时间紧急的情况下，倾向于做出最优的决策。所以在面对毕业去向的抉择时，你会基于已有的信息，快速做出决策。',
          '<b>信息不全容易导致决策失误：</b>自发型的你做出决策是基于自己已有的信息，但是无法保证现有的信息就是足够的，所以会因为信息搜集不全导致做出的决策是不恰当的，容易后悔。',
          '<b>好的决策风格是理智加上相信自己的直觉，而理智的决策是以充分的信息为基础。</b>以毕业去向的抉择为例，自发型的你要想做出一个好的决策，你需要：</br><b>1.	信息搜集尽可能充分：</b>包括“自我”的信息和外部信息两部分。自我部分的信息就涉及到自己的兴趣、价值观、能力、性格特征等方面。对于外部信息而言，如果你是求职，就涉及职业大环境、行业、职业、相关的政策等信息；如果你是考研，就涉及到择校和考虑是否跨考的问题，需要了解学校和专业相关信息，如学校背景、招生信息、培养目标、奖助政策等。</br><b>2.	避免冲动：</b>冲动的状态容易让人失去理智，不利于做出一个好的决策，为此，你需要学会控制自己的冲动情绪。'
        ]
      }
    };
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created: function () {
    setWechatTitle('生涯驿站-决策风格测评')
    this.getReport()
  },
  methods:{
    getReport(){
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url:'/cob/cosDecisionReport.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            let Result = response.data.data;
            if(Result){
              this.cosDecision=Result.cosDecision.listDimensionScore[0].dimensionName;
              // 弹幕
              let num = Math.round(Math.random()),
              text = '的决策风格居然是'+this.cosDecision
              if(num){
                text='居然是一个'+this.cosDecision+'决策的人'
              }
              store.dispatch('finishPlay', {missionId:this.id,cosAnswer:text})
            }
          }
        })
        .catch((error)=>{
          console.log(error);
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .report-type
    padding: 0.2rem
    background-color: #ffffff
    margin: 0.25rem 0.2rem
    margin-bottom:-0.25rem
</style>
